/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';
import {TemplateQuantitativeDriverDTO} from '../model/TemplateQuantitativeDriverDTO';

/**
* TemplateQuantitativeDriverService service.
* @module api/TemplateQuantitativeDriverServiceApi
* @version v0
*/
export class TemplateQuantitativeDriverServiceApi {

    /**
    * Constructs a new TemplateQuantitativeDriverServiceApi. 
    * @alias module:api/TemplateQuantitativeDriverServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getTemplateQuantitativeDriverByControlFunctionAndOperationalScope operation.
     * @callback moduleapi/TemplateQuantitativeDriverServiceApi~getTemplateQuantitativeDriverByControlFunctionAndOperationalScopeCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TemplateQuantitativeDriverDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the quantitative drivers by control function and operational scopes
     * Request to get the quantitative drivers associated to a given control function and one or more given operational scopes (both passed as path variables).
     * @param {Number} controlFunctionEquals 
     * @param {Array.<Number>} operationalScopeIn 
     * @param {module:api/TemplateQuantitativeDriverServiceApi~getTemplateQuantitativeDriverByControlFunctionAndOperationalScopeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTemplateQuantitativeDriverByControlFunctionAndOperationalScope(controlFunctionEquals, operationalScopeIn, callback) {
      
      let postBody = null;
      // verify the required parameter 'controlFunctionEquals' is set
      if (controlFunctionEquals === undefined || controlFunctionEquals === null) {
        throw new Error("Missing the required parameter 'controlFunctionEquals' when calling getTemplateQuantitativeDriverByControlFunctionAndOperationalScope");
      }
      // verify the required parameter 'operationalScopeIn' is set
      if (operationalScopeIn === undefined || operationalScopeIn === null) {
        throw new Error("Missing the required parameter 'operationalScopeIn' when calling getTemplateQuantitativeDriverByControlFunctionAndOperationalScope");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'control-function.equals': controlFunctionEquals,'operational-scope.in': operationalScopeIn
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [TemplateQuantitativeDriverDTO];

      return this.apiClient.callApi(
        '/api/template-quantitative-driver', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}